import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Language} from './common/models/language';

export abstract class LangChange {

  protected constructor(protected _translateService: TranslateService) {
    _translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.onLangChange(Language.getLangObject(event.lang));
      }
    );
  }

  abstract onLangChange(language: Language): void;
}



// WEBPACK FOOTER //
// ./src/app/lang-change.ts